module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.fa277232.woff";


//////////////////
// WEBPACK FOOTER
// ./html/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 1004
// module chunks = 0